// extracted by mini-css-extract-plugin
export var bubble = "_14-0";
export var container = "_14-f";
export var contrastBorder = "_14-g";
export var greyOut = "_14-2";
export var initialsColor0 = "_14-3";
export var initialsColor1 = "_14-4";
export var initialsColor10 = "_14-d";
export var initialsColor11 = "_14-e";
export var initialsColor2 = "_14-5";
export var initialsColor3 = "_14-6";
export var initialsColor4 = "_14-7";
export var initialsColor5 = "_14-8";
export var initialsColor6 = "_14-9";
export var initialsColor7 = "_14-a";
export var initialsColor8 = "_14-b";
export var initialsColor9 = "_14-c";
export var initialsWrapper = "_14-1";
export var large = "_14-l";
export var medium = "_14-k";
export var mediumSmall = "_14-j";
export var mediumSmallMedium = "_14-o";
export var micro = "_14-h";
export var small = "_14-i";
export var tiny = "_14-n";
export var xTiny = "_14-m";